<template>
  <div id="app" :class="{fixios: isIOS && isQYWeixin}">
    <keep-alive include="KeepHome">
      <router-view />
    </keep-alive>
  </div>
</template>

<script>
import { isIOS, isQYWeixin } from '@/utils/weixin'
export default {
  name: 'App',
  components: {
  },
  resetPage: {
    inserted: function(el) {
      document.body.addEventListener('focusout', e => {
        const targetTagName = e.target.tagName.toLowerCase()
        if (targetTagName !== 'input' && targetTagName !== 'textarea') { return }
        // if (/(iPhone|iPad|iPod|iOS)/i.test(navigator.userAgent)) {
        //   // 软键盘收起的事件处理
        //   setTimeout(() => {
        //     const scrollHeight = document.documentElement.scrollTop || document.body.scrollTop || 0
        //     window.scrollTo(0, Math.max(scrollHeight - 1, 0))
        //   }, 100)
        // }
        // 软键盘收起的事件处理
        setTimeout(() => {
          const scrollHeight = document.documentElement.scrollTop || document.body.scrollTop || 0
          window.scrollTo(0, Math.max(scrollHeight - 1, 0))
        }, 100)
      })
    }
  },
  data() {
    return {
      isIOS: false,
      isQYWeixin: false
    }
  },
  created() {
    this.isIOS = isIOS()
    this.isQYWeixin = isQYWeixin()
    // ios页面输入框失焦要页面重置到顶部
    if (this.isIOS) { // 判断是否是ios端
      let flag = false
      let pageBackNormFunc
      document.body.addEventListener('focusin', () => {
        // 软键盘弹起事件
        flag = true
        pageBackNormFunc && clearTimeout(pageBackNormFunc)
      })
      document.body.addEventListener('focusout', e => {
        const targetTagName = e.target.tagName.toLowerCase()
        // 仅当focusout元素为 input 或 textarea时触发
        if (targetTagName === 'input' || targetTagName === 'textarea') {
          // 软键盘关闭事件
          if (flag) {
            pageBackNormFunc = setTimeout(function() { // // 当键盘收起的时候让页面回到原始位置
              const scrollHeight = document.documentElement.scrollTop || document.body.scrollTop || 0
              window.scrollTo({ top: scrollHeight - 1, left: 0, behavior: 'smooth' })
            }, 200)
          }
        }
        flag = false
      })
    }
  }
}
</script>

<style lang="scss">
html, body{
  margin: 0;
  padding: 0;
  height: 100%;
  // min-height: 1000px;
}
* {
  box-sizing: border-box;
}
@font-face {
  font-family: HYRunYuan;
  src: url("./assets/font/HYRunYuan-45W.ttf");
}
@font-face {
  font-family: HYRunYuan-DEW;
  src: url("./assets/font/HYRunYuan-65W.ttf");
}
#app {
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: center;
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  min-height: 100%;
  // overflow-y: auto;
  // -webkit-overflow-scrolling: touch;

  &.fixios {
    padding-bottom: 50px;
  }
}
</style>
